var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-authorization-container',{attrs:{"page":_vm.page,"require-admin":""}},[_c('h2',{staticClass:"mb-4"},[_vm._v("Edit Tier")]),_c('admin-tier-form',{attrs:{"is-update":"","data":_vm.data}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }